import Link from 'next/link'
import { Card, Col, Row } from 'react-bootstrap'
import { FaAngleRight } from 'react-icons/fa'
import { HELP_NOTION_LINKS } from 'web_core/utils'
import styles from '~/styles/_pricing.module.scss'

type Feature = {
  name: string
  description: string
  image_url: string
  usage_url: string
}

const FEATURES: Feature[] = [
  {
    name: 'LaTeXエクスポート',
    description: 'コンテンツをゼミ、論文、レポートで使いやすい形式に',
    image_url: '/images/latex_export.png',
    usage_url: HELP_NOTION_LINKS['LATEX_EXPORT'],
  },
  {
    name: '共同編集',
    description: 'リアルタイムに同期しながら複数人でコンテンツの作成が可能に',
    image_url: '/images/collaborative_edit.png',
    usage_url: HELP_NOTION_LINKS['COLLABORATIVE_EDIT'],
  },
  {
    name: '公開範囲の設定',
    description:
      '非公開、特定の人への限定公開、URLを知っている人への限定公開、完全公開が選択可能に',
    image_url: '/images/visibility_select.png',
    usage_url: HELP_NOTION_LINKS['VISIBILITY_SELECT'],
  },
  {
    name: '広告の非表示',
    description: 'あなたが投稿したコンテンツと閲覧する全ページの広告が非表示に',
    image_url: '/images/ad_remove.png',
    usage_url: HELP_NOTION_LINKS['AD_REMOVE'],
  },
]

export const FeaturesSection = () => (
  <section
    key="feature"
    className={`${styles['bg-gray']} py-7 px-6 ${styles.feature}`}
    style={{ padding: '0px 32px' }}
  >
    <div className="mx-auto" style={{ maxWidth: 980 }}>
      <h2 className={`${styles.h2} mb-5`}>プレミアム機能</h2>
      <Row xs={1} md={2} className="g-4 m-0">
        {FEATURES.map((feature) => (
          <Col key={feature.name} className="m-0">
            <div>
              <hr className="my-7 mx-n3" />
              <Card
                className="d-flex flex-column flex-sm-row justify-content-center align-items-center bg-transparent border-0 mx-auto"
                style={{ maxWidth: 441 }}
              >
                <Row xs={1} sm={2} className="w-100 m-0">
                  <Col sm={5} className="text-center p-0">
                    <Card.Img
                      className="w-100"
                      src={feature.image_url}
                      style={{ maxWidth: 180 }}
                    />
                  </Col>
                  <Col sm={7} className="d-flex p-0">
                    <Card.Body className="flex-grow-1 p-0 bg-transparent">
                      <Card.Title className={styles['feature-name']} as="h3">
                        {feature.name}
                      </Card.Title>
                      <Card.Text className={styles['feature-description']}>
                        {feature.description}
                        <p>
                          <Link href={feature.usage_url} passHref>
                            <a className="d-flex align-items-center mt-2">
                              詳細はこちら
                              <FaAngleRight />
                            </a>
                          </Link>
                        </p>
                      </Card.Text>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </div>
          </Col>
        ))}
        <Col className="m-0">
          <hr className="mt-7 mx-n3" />
        </Col>
        <Col className="d-none d-md-block m-0">
          <hr className="mt-7 mx-n3" />
        </Col>
      </Row>
    </div>
  </section>
)
